import type { ReactNode } from 'react';
import { Button } from 'antd';
import HeartIllustration from './HeartIllustration';
import styles from './EmptyState.module.css';

interface EmptyStateProps {
  illustration?: ReactNode;
  headline: string;
  subtext: string;
  action?: { label: string; onClick: () => void };
  children?: ReactNode;
}

export default function EmptyState({
  illustration = <HeartIllustration />,
  headline,
  subtext,
  action,
  children,
}: EmptyStateProps) {
  return (
    <div className={styles.canvas}>
      <div className={styles.center}>
        {illustration}
        <h1 className={styles.headline}>{headline}</h1>
        <p className={styles.subtext}>{subtext}</p>
        {action && (
          <Button
            type="default"
            className={styles.primaryAction}
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        )}
        {children}
      </div>
    </div>
  );
}
